import(/* webpackMode: "eager", webpackExports: ["ReactQueryDevtools"] */ "/vercel/path0/node_modules/.pnpm/@tanstack+react-query-devtools@5.83.0_@tanstack+react-query@5.83.0_react@19.1.2__react@19.1.2/node_modules/@tanstack/react-query-devtools/build/modern/index.js");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/vercel/path0/node_modules/.pnpm/next-intl@3.26.5_next@15.5.15_@babel+core@7.28.0_supports-color@8.1.1__@opentelemetry+a_8cff2537bbbe38378df2638e62c098cb/node_modules/next-intl/dist/esm/shared/NextIntlClientProvider.js");
;
import(/* webpackMode: "eager" */ "/vercel/path0/src/core/auth/auth-initializer-wrapper.tsx");
;
import(/* webpackMode: "eager" */ "/vercel/path0/src/core/auth/auth-initializer.tsx");
;
import(/* webpackMode: "eager" */ "/vercel/path0/src/core/guards/components/route-guard.tsx");
;
import(/* webpackMode: "eager" */ "/vercel/path0/src/core/guards/hooks/use-role-navigation.ts");
;
import(/* webpackMode: "eager" */ "/vercel/path0/src/core/hooks/use-mobile.tsx");
;
import(/* webpackMode: "eager" */ "/vercel/path0/src/core/providers/dnd-provider.tsx");
;
import(/* webpackMode: "eager" */ "/vercel/path0/src/core/providers/notification-provider.tsx");
;
import(/* webpackMode: "eager" */ "/vercel/path0/src/core/providers/react-query-provider.tsx");
;
import(/* webpackMode: "eager" */ "/vercel/path0/src/core/theme/presentation/providers/theme.provider.tsx");
